import { render } from "./ModuleAssessment.vue?vue&type=template&id=b3db3e4e&scoped=true"
import script from "./ModuleAssessment.vue?vue&type=script&lang=js"
export * from "./ModuleAssessment.vue?vue&type=script&lang=js"

import "./ModuleAssessment.vue?vue&type=style&index=0&id=b3db3e4e&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3db3e4e"]])

export default __exports__